<template>
  <ModalIncompleteSignUp
    v-if="result === 'LocalSignInResult.IncompleteSignUp'"
    :confirmEmail="incompleteEmail"
    @close="onModalCloseIncompleteSignUpLocal"
    :openOnInit="result === 'LocalSignInResult.IncompleteSignUp'"
  />
  <ModalException
    v-if="result === 'OauthSignInResult.Exception'"
    @close="onModalCloseException"
    :openOnInit="result === 'OauthSignInResult.Exception'"
  />
  <ModalCantRetrieveEmail
    v-if="result === 'OauthSignInResult.CantRetrieveEmail'"
    @close="onModalCloseCantRetrieveEmail"
    :openOnInit="result === 'OauthSignInResult.CantRetrieveEmail'"
  />
  <ModalUserNotFound
    v-if="result === 'OauthSignInResult.UserNotFound'"
    @close="onModalCloseUserNotFound"
    :email="userNotFoundEmail"
    :openOnInit="result === 'OauthSignInResult.UserNotFound'"
  />
  <ModalIncompleteSignUp
    v-if="result === 'OauthSignInResult.IncompleteSignUp'"
    @close="onModalCloseIncompleteSignUpOauth"
    :openOnInit="result === 'OauthSignInResult.IncompleteSignUp'"
  />
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <img class="mx-auto h-[100px] w-auto" src="/img/spike-logo.svg" alt="Spike" />
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign in to your account</h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div
        class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10"
        :class="result === 'LocalSignInResult.Fail' ? 'shakeX' : ''"
      >
        <div class="space-y-6">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700"> Email address </label>
            <div class="mt-1">
              <input
                v-model="email"
                name="email"
                type="email"
                autocomplete="on"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary-600 sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
            <div class="mt-1">
              <input
                v-model="password"
                name="password"
                type="password"
                autocomplete="off"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
              />
            </div>
          </div>

          <div class="flex items-center justify-between">
            <!--
            <div class="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                class="h-4 w-4 text-primary focus:ring-primary-600 border-gray-300 rounded"
              />
              <label for="remember-me" class="ml-2 block text-sm text-gray-900"> Remember me </label>
            </div>
            -->

            <div class="text-sm text-center w-full">
              <a :href="forgotRoute" class="font-medium text-primary hover:text-primary-600">Forgot your password?</a>
            </div>
          </div>

          <div>
            <button
              type="submit"
              class="w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-600 disabled:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-600"
              :disabled="!email || !password || result === 'loading' || result === 'LocalSignInResult.Success'"
              @click="onLocalSignInStart()"
            >
              <div v-if="result === 'loading'">Signing in ...</div>
              <div v-else-if="result === 'LocalSignInResult.Success'">Signed in</div>
              <div v-else>Sign in</div>
            </button>
          </div>
        </div>
        <div class="mt-6 flex w-full justify-center text-sm">
          <template v-if="result === 'loading'">
            <ScalingDots />
          </template>
          <template v-else-if="result === 'exception'">
            <XCircleIcon class="w-5 h-5 text-red-600" aria-hidden="true" />
            <span class="ml-2 text-red-600">failed to contact the server, please retry</span>
          </template>
          <template v-else-if="result === 'LocalSignInResult.Fail'">
            <XCircleIcon class="w-5 h-5 text-red-600" aria-hidden="true" />
            <span class="ml-2 text-red-600">username or password incorrect</span>
          </template>
          <template v-else-if="result === 'LocalSignInResult.Success'">
            <CheckCircleIcon class="w-5 h-5 text-green-600" aria-hidden="true" />
            <span class="ml-2 text-green-600">success</span>
          </template>
          <template v-else>
            <!-- dummy - keep height -->
            <span>&nbsp;</span>
          </template>
        </div>

        <div class="mt-6">
          <div class="relative">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-300" />
            </div>
            <div class="relative flex justify-center text-sm">
              <span class="px-2 bg-white text-gray-500"> Or sign in with </span>
            </div>
          </div>

          <div class="mt-6 grid grid-cols-2 gap-2">
            <div>
              <a
                :href="signInGoogleUrl"
                class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
              >
                <span class="sr-only">Sign in with Google</span>
                <GoogleIcon class="w-5 h-5" aria-hidden="true" />
              </a>
            </div>

            <div>
              <a
                :href="signInGithubUrl"
                class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
              >
                <span class="sr-only">Sign in with GitHub</span>
                <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fill-rule="evenodd"
                    d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md text-center text-gray-500">
      Don't have an account yet?
      <a :href="signUpRoute" class="font-medium underline text-primary hover:text-primary-600">Sign Up</a>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  AppName,
  Url,
  LocalSignInRes,
  LocalSignInResult,
  LocalSignInRes_IncompleteSignUp,
  LocalSignInReq,
  ScreenRoute,
  OauthSignInResult,
  OauthSignInResult_UserNotFound,
  FlowOrder,
  ScreenName,
  Flow,
} from "@spike/app2-sitemap/src/auth.js";
import { Url as DefaultUrls } from "@spike/app2-sitemap/src/defaults.js";
import axios from "axios";
import ModalException from "../components/SignIn/ModalException.vue";
import ModalCantRetrieveEmail from "../components/SignIn/ModalCantRetrieveEmail.vue";
import ModalUserNotFound from "../components/SignIn/ModalUserNotFound.vue";
import ModalIncompleteSignUp from "../components/SignIn/ModalIncompleteSignUp.vue";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/vue/solid";
import GoogleIcon from "@icons/brand/Google";
import sleep from "@util/sleep";
import { onMounted, ref } from "vue";
import ScalingDots from "../components/spinners/ScalingDots.vue";
import * as Nav from "../navigation";
import { Screen } from "../routes";

const forgotRoute = ref("#" + ScreenRoute.ForgotPasswordStart);
const signUpRoute = ref("#" + ScreenRoute.SignUp);
const email = ref(null);
const password = ref(null);
const signInGithubUrl = ref(Url.server.github.signIn);
const signInGoogleUrl = ref(Url.server.google.signIn);
const returnUrl = query("returnUrl") as string | undefined;
if (returnUrl) {
  signInGithubUrl.value = signInGithubUrl.value + "?returnUrl=" + returnUrl; // add returnUrl if present
  signInGoogleUrl.value = signInGoogleUrl.value + "?returnUrl=" + returnUrl; // add returnUrl if present
}
const userNotFoundEmail = ref<string | undefined>(undefined);
const incompleteEmail = ref(true);
const result = ref<string | null>(null);
// testing:
// const result = ref("loading");
// const result = ref("exception");
// const result = ref("LocalSignInResult.Success");
// const result = ref("LocalSignInResult.Fail");
// const result = ref("LocalSignInResult.IncompleteSignUp");

onMounted(async () => {
  try {
    // console.log("onMounted:", ScreenRoute.SignIn);

    // oauth errors ocurr by redirecting to sign-in page
    // see /spike/v9/priv/stack/app.spikedata.co.za/src/server/src/routes/auth/config.js : exports.{github,google}.paths.signIn.redirect

    // note: 2022-03-08 changed from querystring to redirectData:
    const redirectData = Nav.getRedirectData(AppName, ScreenRoute.SignIn);
    // console.log("redirectData:", ScreenRoute.SignIn, redirectData);

    // testing:
    // const fail = false;
    // const fail = OauthSignInResult.Exception;
    if (redirectData && redirectData.step) {
      switch (redirectData.step) {
        // case OauthSignInResult.Success:
        //  NOTE: redirects directly from SX to defaults.Urls.signIn
        case OauthSignInResult.Exception:
          return onOauthSignInResultException();
        case OauthSignInResult.CantRetrieveEmail:
          return onOauthSignInResultCantRetrieveEmail();
        case OauthSignInResult.UserNotFound:
          return onOauthSignInResultUserNotFound(redirectData.data as OauthSignInResult_UserNotFound);
        case OauthSignInResult.IncompleteSignUp:
          return onOauthSignInResultIncompleteSignUp();
        default:
        // console.error("broken code: unknown OauthSignInResult:", redirectData.step);
      }
    }
  } catch (e) {
    // console.error("auth onMounted failed:", e);
  }
});

function query(param: string, isNumber = false) {
  const searchParams = new URLSearchParams(window.location.search);
  let p = searchParams.get(param);
  if (p) {
    return isNumber ? +p : p;
  }
  return undefined;
}

//#region Local sign-in

async function onLocalSignInStart() {
  try {
    if (!email.value || !password.value) {
      alert("email or password is empty");
      return;
    }
    const _email = email.value;
    const _password = password.value;

    if (!validate(_email, _password)) {
      return;
    }

    result.value = "loading";
    const requestBody: LocalSignInReq = {
      email: _email,
      password: _password,
    };
    const response = await axios.post(Url.server.local.signIn, requestBody);
    // console.log("response:", response);
    const res: LocalSignInRes = response.data;

    switch (res.result) {
      case LocalSignInResult.Fail:
        onLocalSignInFail();
        break;
      case LocalSignInResult.Success:
        onLocalSignInSuccess();
        break;
      case LocalSignInResult.IncompleteSignUp:
        onLocalSignInIncompleteSignUp(res as LocalSignInRes_IncompleteSignUp);
        break;
      case LocalSignInResult.Locked:
        onLocalSignInLocked();
        break;
      default:
        onLocalSignInException();
        break;
    }
  } catch (e) {
    // console.error("sign-in failed:", e);
    onLocalSignInException();
  }
}

function validate(email: string, password: string) {
  if (!email.trim() && !password.trim()) {
    alert("email & password missing, please try again");
    return false;
  }
  if (!email.trim()) {
    alert("email missing, please try again");
    return false;
  }
  if (!password.trim()) {
    alert("password missing, please try again");
    return false;
  }
  return true;
}

async function onLocalSignInIncompleteSignUp(res: LocalSignInRes_IncompleteSignUp) {
  result.value = "LocalSignInResult.IncompleteSignUp";
  if (res.data.incompleteStep === "email") {
    Nav.startFlow(Flow.signIn_local_incomplete_email);
    incompleteEmail.value = true;
  } else {
    Nav.startFlow(Flow.signIn_local_incomplete_team);
    incompleteEmail.value = false;
  }
}

async function onLocalSignInException() {
  result.value = "exception";
}

async function onLocalSignInFail() {
  result.value = "LocalSignInResult.Fail";
}

async function onLocalSignInSuccess() {
  Nav.startFlow(Flow.signIn_local_complete);
  Nav.complete(ScreenName.SignIn);
  // show message
  result.value = "LocalSignInResult.Success";

  // wait 2 seconds then go to url
  await sleep(2000);

  const returnUrl = query("returnUrl") as string | undefined;
  if (returnUrl) {
    location.href = returnUrl;
  } else {
    location.href = DefaultUrls.signIn;
  }
}

async function onLocalSignInLocked() {
  Nav.complete(Screen.SignIn);
  Nav.setActive(Screen.Locked, true);
}

function onModalCloseIncompleteSignUpLocal(i: number) {
  // for local sign-up could be either email verification or team-create that is incomplete
  let screen: Screen = incompleteEmail.value ? Screen.VerifyLocalEmail : Screen.TeamCreate;
  Nav.complete(ScreenName.SignIn);
  Nav.setActive(screen, true);
}

function onModalCloseIncompleteSignUpOauth(i: number) {
  // for oauth sign-up incomplete step can only be team-create (email is auto confirmed, team-invite is skipped)
  Nav.complete(ScreenName.SignIn);
  Nav.setActive(Screen.TeamCreate, true);
}

//#endregion

//#region Oauth sign-in

function onOauthSignInResultException() {
  result.value = "OauthSignInResult.Exception";
}

function onOauthSignInResultCantRetrieveEmail() {
  result.value = "OauthSignInResult.CantRetrieveEmail";
}

function onOauthSignInResultUserNotFound(data: OauthSignInResult_UserNotFound) {
  userNotFoundEmail.value = data.email;
  result.value = "OauthSignInResult.UserNotFound";
}

function onOauthSignInResultIncompleteSignUp() {
  Nav.startFlow(Flow.signIn_oauth_incomplete);
  result.value = "OauthSignInResult.IncompleteSignUp";
}

function onModalCloseException(i: number) {
  result.value = null;
}

function onModalCloseCantRetrieveEmail(i: number) {
  result.value = null;
}

function onModalCloseUserNotFound(i: number) {
  if (i === 1) {
    // Go to sign-up
    // Nav.complete(ScreenName.SignIn);
    Nav.setActive(Screen.SignUp, true);
  } else {
    // Retry
    result.value = null;
    Nav.setActive(Screen.SignIn, true); // already on SignIn screen, but will clear out step i.e. #/sign-in/exception => #/sign-in
  }
}

//#endregion
</script>
